import Icon from '../components/Icon.vue'

Icon.register({
  'globe-europe': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM448 256c0-110.3-89.7-200-200.2-200-1.9 0-3.8 0.2-5.7 0.3l-28.9 21.7c-2 1.5-3.2 3.9-3.2 6.4v20c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8l16-16h20.7c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8l-26.8 26.8c-1.2 1.2-2.7 2.1-4.4 2.7l-40 13.3c-3.3 1.1-5.5 4.2-5.5 7.6 0 6.6-2.6 12.9-7.2 17.5l-20.1 20.1c-3 3-4.7 7.1-4.7 11.3v25.3c0 8.8 7.2 16 16 16h22.1c6.1 0 11.6-3.4 14.3-8.8l9.4-18.7c1.4-2.7 4.2-4.4 7.2-4.4h3.1c4.4 0 8 3.6 8 8 0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-2.2c0-3.5 2.2-6.5 5.5-7.6l31.6-10.5c6.5-2.2 10.9-8.3 10.9-15.2v-4.5c0-8.8 7.2-16 16-16h36.7c6.2 0 11.3 5.1 11.3 11.3v9.4c0 6.2-5.1 11.3-11.3 11.3h-32c-3 0-5.9 1.2-8 3.3l-9.4 9.4c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h16c3 0 5.9 1.2 8 3.3l9.4 9.4c2.1 2.1 3.3 5 3.3 8v8.7l-12.5 12.5c-4.6 4.6-4.6 12.1-0.1 16.7l32 32.6c3 3.1 7.1 4.8 11.4 4.8h20.3c6.9-20.2 10.8-41.9 10.8-64.4zM130.1 149.1c0 6.2 5.1 11.3 11.3 11.3h16c3 0 5.9-1.2 8-3.3l9.4-9.4c2.1-2.1 3.3-5 3.3-8v-16c0-6.2-5.1-11.3-11.3-11.3-3 0-5.9 1.2-8 3.3l-25.4 25.4c-2.1 2.1-3.3 5-3.3 8zM258.1 455.5c71.1-3.6 132.5-44.2 164.9-103.1h-13.4c-4.8 0-9.5-1.9-12.9-5.3l-17.3-17.3c-6-6-14.1-9.4-22.6-9.4h-18.3l-43.2-37.1c-8.2-7-18.7-10.9-29.6-10.9h-31.2c-8.2 0-16.3 2.3-23.4 6.5l-42.9 25.7c-13.7 8.2-22.1 23-22.1 39v23.9c0 14.3 6.7 27.8 18.2 36.4l22.2 16.7c8.7 6.5 24.6 11.8 35.4 11.8h20.2c8.8 0 16 7.2 16 16v7.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-europe.js
// module id = 1394
// module chunks = 0